export const isSessionStorageSupported = () => {
    try {
        return "sessionStorage" in window && window.sessionStorage !== null;
    }
    catch (e) {
        return false;
    }
};
const storageServiceFactory = (getKey) => ({
    getKey,
    get: (item) => {
        if (!item || !isSessionStorageSupported()) {
            return null;
        }
        const filterObject = window.sessionStorage.getItem(getKey(item));
        return filterObject && JSON.parse(filterObject);
    },
    set: (item, data) => {
        if (!isSessionStorageSupported()) {
            return false;
        }
        window.sessionStorage.setItem(getKey(item), JSON.stringify(data));
        return true;
    },
    getItem: () => {
        if (!isSessionStorageSupported()) {
            return null;
        }
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
        const filterObject = window.sessionStorage.getItem(getKey());
        return filterObject && JSON.parse(filterObject);
    },
    // @ts-expect-error - TS2322 - Type '(data: T) => boolean' is not assignable to type '() => boolean'.
    setItem: (data) => {
        if (!isSessionStorageSupported()) {
            return false;
        }
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
        window.sessionStorage.setItem(getKey(), JSON.stringify(data));
        return true;
    },
    removeItem: () => {
        if (!isSessionStorageSupported()) {
            return false;
        }
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
        window.sessionStorage.removeItem(getKey());
        return true;
    },
});
export const MessageRecipientsStorageService = storageServiceFactory((item) => `recipients`);
